module.exports = __webpack_public_path__ + "static/media/logo.50359c8a.svg";